import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'toggle']
  static classes = ['open']

  connect() {
    this.close()
  }

  toggle() {
    this.opened ? this.close() : this.open()
  }

  open() {
    this.panelTarget.classList.add(this.openClass)
    document.body.classList.add('nav-is-open')
    if (this.hasToggleTarget) this.toggleTarget.setAttribute('aria-expanded', 'true')
  }

  close() {
    this.panelTarget.classList.remove(this.openClass)
    document.body.classList.remove('nav-is-open')
    if (this.hasToggleTarget) this.toggleTarget.setAttribute('aria-expanded', 'false')
  }

  closeOnOutsideClick(event) {
    if (!this.opened || this.element.contains(event.target)) return
    this.close()
  }

  closeOnEscape(event) {
    if (event.key === 'Escape') this.close()
  }

  get opened() {
    return this.panelTarget.classList.contains(this.openClass)
  }
}
